// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"161":"FormMistico","758":"Transition"}[chunkId] + "." + {"161":"fbe5e1a1","758":"98d85550"}[chunkId] + ".css";
};